<lh-navigation-layout-page sourceItem="darkmode" topMenuVisibility="Desktop">
    <vn-dark-mode (onChange)="track($event)" />
</lh-navigation-layout-page>
